import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, IconButton, useTheme } from "@mui/material";
import { Flag } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { formatClientName } from "../../utils/commonMethods";
import HulpmiddelList from "../TaskOverview/HulpmiddelList";
import { ProjectData, Tool, Material } from "../../interfaces/TaskDetails";
import useResponsive from "../../hooks/useResponsive";

export type IProjectDetailsProps = {
  projectData: ProjectData | null;
  tool: Tool[];
  medewerkers: string;
  isFlag: boolean | null;
  onFlagStatusChange: () => void;
  setIsLoading: () => void;
};

const ProjectDetails: React.FC<IProjectDetailsProps> = ({
  projectData,
  tool,
  medewerkers,
  isFlag,
  onFlagStatusChange,
  setIsLoading,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: isMobile || isTablet ? "90%" : "100%",
        mt: "5px",
      }}
    >
      {/* Green Paper Container */}
      <Paper
        sx={{
          p: 2,
          bgcolor: theme.palette.blueColors.main,
          width: isMobile || isTablet ? "100%" : "90%",
          borderRadius: "10px",
        }}
      >
        <Box>
          {[
            { label: "Projectnaam", value: projectData?.project_name },
            {
              label: "Opdrachtgever",
              value: formatClientName(projectData?.client_name ?? null),
            },
            { label: "Ecoloog", value: projectData?.ecologist_name },
            {
              label: "Hulpmiddel",
              value: <HulpmiddelList data={tool} loader={setIsLoading} />,
            },
            { label: "Overige medewerker(s)", value: medewerkers },
          ].map((item, index) => (
            <Box key={index} sx={{ display: "flex", mb: 1 }}>
              <Typography
                fontFamily={"Nunito Sans Regular700"}
                fontSize={"14px"}
                sx={{
                  width: "50%",
                  mr: 1,
                  color: theme.palette.secondary.main,
                }}
              >
                {item?.label}
              </Typography>

              <Box
                sx={{
                  width: "80%",
                  color: theme.palette.secondary.main,
                  fontFamily: "Nunito Sans Regular700",
                  fontSize: "14px",
                }}
              >
                {item?.value}
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>
      {isDesktop && (
        <Box
          sx={{
            display: "flex",
            width: "10%",
            justifyContent: "flex-end",
          }}
        >
          {isFlag ? (
            <Flag
              sx={{
                color: "red",
                fontSize: 40,
              }}
            />
          ) : (
            <IconButton
              onClick={onFlagStatusChange}
              sx={{
                padding: "0px",
              }}
            >
              <Flag
                sx={{
                  color: theme.palette.primary.main,
                  fontSize: 40,
                }}
              />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export { ProjectDetails };
